var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "url(#paint0_linear_1152_22674)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1152_22674)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 72C59.9117 72 72 59.9117 72 45C72 30.0883 59.9117 18 45 18C30.0883 18 18 30.0883 18 45C18 59.9117 30.0883 72 45 72Z",
    fill: "url(#paint1_linear_1152_22674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.0003 71.1878C37.9102 71.1878 31.1047 68.3988 26.0538 63.4231C21.0029 58.4474 18.1121 51.6845 18.0059 44.5952C18.0059 44.7292 18.0059 44.8743 18.0059 44.9999C18.0059 52.1607 20.8505 59.0283 25.914 64.0917C30.9775 69.1552 37.845 71.9999 45.0059 71.9999C52.1667 71.9999 59.0343 69.1552 64.0977 64.0917C69.1612 59.0283 72.0059 52.1607 72.0059 44.9999C72.0059 44.8631 72.0059 44.7208 72.0059 44.5952C71.8996 51.6864 69.0072 58.451 63.9539 63.427C58.9006 68.403 52.0923 71.1908 45.0003 71.1878Z",
    fill: "#FDF356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0002 19.0158C52.073 19.016 58.8632 21.7915 63.9112 26.7455C68.9591 31.6995 71.8616 38.4364 71.9946 45.5079C71.9946 45.3377 71.9946 45.1702 71.9946 45C71.9946 37.8392 69.15 30.9716 64.0865 25.9081C59.023 20.8446 52.1555 18 44.9946 18C37.8338 18 30.9662 20.8446 25.9027 25.9081C20.8393 30.9716 17.9946 37.8392 17.9946 45C17.9946 45.1702 17.9946 45.3377 17.9946 45.5079C18.1277 38.4345 21.0318 31.6959 26.0821 26.7416C31.1324 21.7873 37.9255 19.0131 45.0002 19.0158Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.0004 71.8743C59.8427 71.8743 71.8748 59.8422 71.8748 44.9999C71.8748 30.1576 59.8427 18.1255 45.0004 18.1255C30.1581 18.1255 18.126 30.1576 18.126 44.9999C18.126 59.8422 30.1581 71.8743 45.0004 71.8743Z",
    fill: "url(#paint2_radial_1152_22674)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M45.0004 18.1006C37.9963 18.1009 31.2687 20.8346 26.2495 25.7198C21.2303 30.6051 18.3157 37.2562 18.126 44.2578C21.0981 46.0187 25.7725 44.6094 28.8283 43.0801C31.4571 41.8662 34.6888 42.2708 37.5213 42.4745C44.5957 43.0801 51.4748 46.1024 58.5437 44.2941C59.9585 43.8894 61.979 42.0615 63.3939 43.281C64.5641 44.2411 65.9853 44.8451 67.4887 45.0212C68.9921 45.1973 70.5144 44.9382 71.8748 44.2745C71.6893 37.27 68.7766 30.6147 63.757 25.7258C58.7373 20.837 52.0074 18.101 45.0004 18.1006Z",
    fill: "url(#paint3_linear_1152_22674)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 65.9107C56.5487 65.9107 65.9107 56.5487 65.9107 45.0001C65.9107 33.4514 56.5487 24.0894 45.0001 24.0894C33.4514 24.0894 24.0894 33.4514 24.0894 45.0001C24.0894 56.5487 33.4514 65.9107 45.0001 65.9107Z",
    fill: "url(#paint4_linear_1152_22674)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 64.8947C55.988 64.8947 64.8952 55.9875 64.8952 44.9999C64.8952 34.0122 55.988 25.105 45.0004 25.105C34.0127 25.105 25.1055 34.0122 25.1055 44.9999C25.1055 55.9875 34.0127 64.8947 45.0004 64.8947Z",
    fill: "#EE9B00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0003 64.0826C55.5394 64.0826 64.0831 55.5389 64.0831 44.9998C64.0831 34.4606 55.5394 25.917 45.0003 25.917C34.4611 25.917 25.9175 34.4606 25.9175 44.9998C25.9175 55.5389 34.4611 64.0826 45.0003 64.0826Z",
    fill: "url(#paint5_radial_1152_22674)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M45.0001 62.6624C34.6298 62.6624 26.1935 54.7982 25.9229 44.4922C25.9229 44.6624 25.9229 44.8299 25.9229 45.0001C25.9229 50.0612 27.9334 54.9149 31.5121 58.4937C35.0908 62.0724 39.9446 64.0829 45.0056 64.0829C50.0667 64.0829 54.9205 62.0724 58.4992 58.4937C62.0779 54.9149 64.0884 50.0612 64.0884 45.0001C64.0884 44.8299 64.0884 44.6624 64.0884 44.4922C63.8066 54.7982 55.3703 62.6624 45.0001 62.6624Z",
    fill: "#FDF356"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.9333 42.371C56.8373 42.0702 56.6583 41.8026 56.4169 41.5992C56.1754 41.3957 55.8813 41.2647 55.5686 41.2212L49.3119 40.3115L46.5212 34.6436C46.382 34.3603 46.1663 34.1218 45.8985 33.955C45.6306 33.7881 45.3214 33.6997 45.0058 33.6997C44.6903 33.6997 44.381 33.7881 44.1132 33.955C43.8454 34.1218 43.6296 34.3603 43.4905 34.6436L40.6998 40.3115L34.4319 41.2324C34.1196 41.2774 33.8261 41.409 33.5848 41.6123C33.3435 41.8157 33.1641 42.0825 33.0667 42.3827C32.9694 42.6828 32.9581 43.0042 33.0342 43.3104C33.1102 43.6167 33.2705 43.8955 33.497 44.1152L38.0235 48.5161L36.9547 54.7449C36.8997 55.0557 36.9336 55.3757 37.0526 55.668C37.1716 55.9603 37.3708 56.213 37.6272 56.397C37.883 56.581 38.1847 56.6906 38.499 56.7138C38.8132 56.7369 39.1277 56.6727 39.4077 56.5282L45.0002 53.5868L50.5956 56.5254C50.8377 56.655 51.108 56.723 51.3826 56.7236C51.6292 56.7233 51.8728 56.6693 52.0965 56.5654C52.3202 56.4615 52.5185 56.3102 52.6779 56.1219C52.8372 55.9336 52.9536 55.713 53.0191 55.4752C53.0846 55.2374 53.0975 54.9882 53.057 54.7449L51.977 48.5161L56.5007 44.104C56.729 43.8854 56.8908 43.6067 56.9674 43.3C57.0439 42.9933 57.0321 42.6712 56.9333 42.371Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M56.5455 42.2932C56.4726 42.0649 56.3368 41.8618 56.1537 41.7073C55.9705 41.5528 55.7474 41.4531 55.5101 41.4198L49.0441 40.4793L46.1529 34.6188C46.0472 34.4033 45.8832 34.2217 45.6794 34.0947C45.4757 33.9677 45.2404 33.9004 45.0004 33.9004C44.7603 33.9004 44.525 33.9677 44.3213 34.0947C44.1176 34.2217 43.9535 34.4033 43.8478 34.6188L40.9566 40.4793L34.4906 41.4198C34.2539 41.455 34.0317 41.5556 33.849 41.7101C33.6664 41.8647 33.5304 42.0672 33.4565 42.2948C33.3826 42.5224 33.3736 42.7661 33.4305 42.9985C33.4875 43.2309 33.6082 43.4428 33.779 43.6105L38.0515 47.9667L36.9352 54.4077C36.8961 54.6575 36.9246 54.9133 37.0179 55.1484C37.1111 55.3835 37.2657 55.5893 37.4655 55.7444C37.7194 55.9217 38.0126 56.0346 38.3198 56.0735C38.627 56.1124 38.9391 56.0761 39.2292 55.9677L45.0004 52.923L50.7827 55.9649C51.0277 56.083 51.2978 56.1396 51.5696 56.1299C51.8414 56.1201 52.1067 56.0444 52.3427 55.9091C52.7418 55.63 53.1352 54.8932 53.0543 54.4077L51.938 47.9667L56.2106 43.6105C56.3849 43.4448 56.5089 43.2332 56.5681 43.0002C56.6274 42.7671 56.6195 42.522 56.5455 42.2932Z",
    fill: "url(#paint6_linear_1152_22674)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5455 41.0763C56.4725 40.8479 56.3367 40.6445 56.1537 40.4895C55.9706 40.3346 55.7476 40.2343 55.5102 40.2001L49.0441 39.2624L46.1529 33.4019C46.0465 33.1872 45.8822 33.0066 45.6785 32.8803C45.4749 32.7539 45.24 32.687 45.0004 32.687C44.7608 32.687 44.5259 32.7539 44.3223 32.8803C44.1186 33.0066 43.9543 33.1872 43.8478 33.4019L40.9567 39.2624L34.4906 40.2001C34.2534 40.2349 34.0306 40.3354 33.8474 40.4902C33.6642 40.6449 33.5279 40.8478 33.4539 41.0759C33.3799 41.304 33.3711 41.5483 33.4286 41.7811C33.486 42.0139 33.6074 42.2261 33.779 42.3936L38.459 46.9536L37.3427 53.3917C37.3008 53.6283 37.3263 53.8718 37.4163 54.0946C37.5062 54.3174 37.657 54.5104 37.8515 54.6515C38.0459 54.7927 38.2761 54.8763 38.5157 54.8929C38.7554 54.9094 38.9949 54.8583 39.2069 54.7452L45.0004 51.7061L50.7827 54.7452C50.9948 54.8571 51.234 54.9074 51.4732 54.8903C51.7124 54.8733 51.942 54.7895 52.1361 54.6487C52.3301 54.5078 52.4808 54.3153 52.5711 54.0932C52.6614 53.871 52.6877 53.628 52.6469 53.3917L51.5306 46.9536L56.2106 42.3936C56.3847 42.2277 56.5084 42.0161 56.5677 41.7832C56.6269 41.5502 56.6192 41.3052 56.5455 41.0763Z",
    fill: "#EE9B00"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8792 33.9434L48.8401 39.9461L55.4652 40.9089C55.6469 40.9345 55.8178 41.0106 55.9584 41.1286C56.099 41.2465 56.2036 41.4016 56.2603 41.5762C56.3171 41.7507 56.3236 41.9376 56.2793 42.1157C56.2349 42.2938 56.1414 42.4558 56.0094 42.5833L51.215 47.255L52.348 53.8522C52.3792 54.0326 52.3591 54.2181 52.2902 54.3877C52.2213 54.5573 52.1062 54.7042 51.958 54.8117C51.8098 54.9193 51.6344 54.9831 51.4518 54.996C51.2692 55.0089 51.0866 54.9704 50.9248 54.8847L45.0001 51.7675L39.0754 54.882C38.9136 54.9676 38.731 55.0061 38.5484 54.9932C38.3658 54.9803 38.1904 54.9165 38.0422 54.809C37.894 54.7014 37.7789 54.5546 37.71 54.3849C37.6411 54.2153 37.621 54.0298 37.6522 53.8494L38.7852 47.2522L33.9908 42.5806C33.8588 42.453 33.7653 42.291 33.7209 42.1129C33.6766 41.9349 33.6831 41.7479 33.7399 41.5734C33.7966 41.3988 33.9012 41.2437 34.0418 41.1258C34.1824 41.0078 34.3533 40.9317 34.535 40.9061L41.1601 39.9434L44.121 33.9406C44.202 33.7764 44.3274 33.6383 44.4829 33.5418C44.6385 33.4452 44.8179 33.3942 45.001 33.3945C45.184 33.3948 45.3633 33.4464 45.5185 33.5434C45.6737 33.6404 45.7987 33.779 45.8792 33.9434Z",
    fill: "url(#paint7_linear_1152_22674)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.696 47.7739L37.6523 53.8493C37.6273 53.9992 37.6368 54.1529 37.6802 54.2986L38.7965 47.8604L38.696 47.7739Z",
    fill: "#FDF356"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5351 41.5115L41.5648 40.5487L44.5286 34.5459C44.8858 33.8176 45.1146 33.8176 45.4718 34.5459L48.4355 40.5487L55.4653 41.5115C55.6466 41.5364 55.8171 41.6123 55.957 41.7304C56.0968 41.8485 56.2002 42.0039 56.2551 42.1785C56.2997 42.0427 56.3141 41.8988 56.2972 41.7568C56.2803 41.6149 56.2326 41.4783 56.1573 41.3568C56.0821 41.2353 55.9811 41.1317 55.8616 41.0533C55.742 40.9749 55.6068 40.9237 55.4653 40.9031L48.8402 39.9403L45.8793 33.9376C45.7985 33.7733 45.6734 33.6349 45.518 33.5382C45.3626 33.4414 45.1832 33.3901 45.0002 33.3901C44.8172 33.3901 44.6378 33.4414 44.4824 33.5382C44.327 33.6349 44.2019 33.7733 44.1211 33.9376L41.1602 39.9403L34.5351 40.9031C34.3936 40.9237 34.2584 40.9749 34.1388 41.0533C34.0192 41.1317 33.9183 41.2353 33.843 41.3568C33.7678 41.4783 33.72 41.6149 33.7031 41.7568C33.6863 41.8988 33.7007 42.0427 33.7453 42.1785C33.8002 42.0039 33.9036 41.8485 34.0434 41.7304C34.1832 41.6123 34.3538 41.5364 34.5351 41.5115Z",
    fill: "#FDF356"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.3046 47.7739L51.2153 47.8604L52.3316 54.2986C52.375 54.1529 52.3845 53.9992 52.3595 53.8493L51.3046 47.7739Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.8792 33.9434L48.8401 39.9461L55.4652 40.9089C55.6469 40.9345 55.8178 41.0106 55.9584 41.1286C56.099 41.2465 56.2036 41.4016 56.2603 41.5762C56.3171 41.7507 56.3236 41.9376 56.2793 42.1157C56.2349 42.2938 56.1414 42.4558 56.0094 42.5833L51.215 47.255L52.348 53.8522C52.3792 54.0326 52.3591 54.2181 52.2902 54.3877C52.2213 54.5573 52.1062 54.7042 51.958 54.8117C51.8098 54.9193 51.6344 54.9831 51.4518 54.996C51.2692 55.0089 51.0866 54.9704 50.9248 54.8847L45.0001 51.7675L39.0754 54.882C38.9136 54.9676 38.731 55.0061 38.5484 54.9932C38.3658 54.9803 38.1904 54.9165 38.0422 54.809C37.894 54.7014 37.7789 54.5546 37.71 54.3849C37.6411 54.2153 37.621 54.0298 37.6522 53.8494L38.7852 47.2522L33.9908 42.5806C33.8588 42.453 33.7653 42.291 33.7209 42.1129C33.6766 41.9349 33.6831 41.7479 33.7399 41.5734C33.7966 41.3988 33.9012 41.2437 34.0418 41.1258C34.1824 41.0078 34.3533 40.9317 34.535 40.9061L41.1601 39.9434L44.121 33.9406C44.202 33.7764 44.3274 33.6383 44.4829 33.5418C44.6385 33.4452 44.8179 33.3942 45.001 33.3945C45.184 33.3948 45.3633 33.4464 45.5185 33.5434C45.6737 33.6404 45.7987 33.779 45.8792 33.9434Z",
    fill: "url(#paint8_radial_1152_22674)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M55.4652 40.909L48.8401 39.9462L45.8792 33.9434C45.7984 33.7792 45.6733 33.6408 45.5179 33.544C45.3625 33.4473 45.1832 33.396 45.0001 33.396C44.8171 33.396 44.6377 33.4473 44.4823 33.544C44.327 33.6408 44.2018 33.7792 44.1211 33.9434L41.1601 39.9462L34.535 40.909C34.3807 40.9304 34.2339 40.9887 34.1071 41.0791C33.9803 41.1695 33.8772 41.2892 33.8066 41.4281C34.6438 42.4774 34.9676 42.6643 36.3378 43.6271C40.5238 45.9964 51.0225 45.5806 53.9332 43.2225C55.0159 42.3406 55.4038 42.2234 56.0597 41.2299C55.9069 41.0545 55.6957 40.9404 55.4652 40.909Z",
    fill: "url(#paint9_linear_1152_22674)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1152_22674",
    x1: 1.86636,
    y1: 0.00000220023,
    x2: 116.318,
    y2: 39.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1152_22674",
    x1: 45,
    y1: 18,
    x2: 45,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1152_22674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7297 14.2855) scale(21.5023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1152_22674",
    x1: 45.0004,
    y1: 67.5043,
    x2: 45.0004,
    y2: 28.3229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1152_22674",
    x1: 45.0001,
    y1: 65.9107,
    x2: 45.0001,
    y2: 14.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F7B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1152_22674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.204 28.557) scale(38.3693)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1152_22674",
    x1: 45.0004,
    y1: 56.1323,
    x2: 45.0004,
    y2: 33.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F3B500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1152_22674",
    x1: 45.0001,
    y1: 33.3964,
    x2: 45.0001,
    y2: 71.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1152_22674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7964 28.9368) scale(19.0828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1152_22674",
    x1: 44.9332,
    y1: 54.7676,
    x2: 44.9332,
    y2: 41.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1152_22674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownToken);
export default __webpack_public_path__ + "static/media/unknown_token.ab8009606c0e7f7db423ab19e313003d.svg";
export { ForwardRef as ReactComponent };